<template>
  <v-app>
    <v-app-bar app color="#231f20" dark>
      <v-layout justify-space-between fill-height align-center>
        <div class="logo-and-lang" style="display: flex; align-items: center;">
          <div @click="backToApp" style="cursor:pointer">
            <LogoLarge />
          </div>
          <LanguageDropdown class="ml-8" />
        </div>
        <h1 class="headline">{{ t('layouts.training.title') }}</h1>
        <v-menu offset-y content-class="user-menu">
          <template v-slot:activator="{ on }">
            <div class="user-menu-trigger" v-on="on">
              <span class="user-name">{{ user.firstName }} {{ user.lastName }}</span>
              <v-btn large text icon>
                <v-icon large>$vuetify.icons.user_circle</v-icon>
              </v-btn>
            </div>
          </template>

          <v-list light class="user-menu-list">
            <v-list-item @click="backToApp">
              <v-list-item-title>{{ t('layouts.training.backToMap') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isUserAdmin === true" :to="{ name: 'admin' }">
              <v-list-item-title>{{ t('layouts.training.admin') }}</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isUserAdmin === true" :to="{ name: 'overwatch' }">
              <v-list-item-title>{{ t('layouts.training.overwatch') }}</v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>
                <a href="https://i911help.zendesk.com/hc/en-us/sections/360009792793-FAQ" target="_blank" style="text-decoration: none !important;color:#1E1F1F">{{ t('layouts.training.contactSupport') }}</a>
              </v-list-item-title>
            </v-list-item>
            <v-list-item @click="signOut" class="sign-out-item">
              <v-list-item-title>{{ t('layouts.training.signOut') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-layout>
    </v-app-bar>
    <v-main>
      <slot />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue'
import store from '@/store'

// Must be high in the component hierarchy for correct DOM positioning.
import EndTrackingModal from '@/components/EndTrackingModal.vue'
import axios from "axios";
import {eventBus} from "@/main";
import LogoLarge from '@/components/LogoLarge.vue';

export default Vue.extend({
  data() {
    return {
      showErrorSnackbar: false,
      isHidden: false,
      seen: false
    }
  },
  methods: {
    t(key: string): string {
      return (this as any).$t(key)
    },
    backToApp() {
      this.$router.push({ name: 'dashboard' })
    },
    changeEmail() {
      store.commit('location/showEditEmailModal', true)
    },
    signOut() {
      store.dispatch('authentication/logout')
      store.dispatch('location/reset')
      // this.$tours.dashboardTour.stop()
      this.$router.push({
        name: 'auth-sign-in'
      })
    },
    toTraining() {
      this.$router.push({
        name: 'training'
      })
    },
    hideLocate() {
      this.isHidden = true
    },
  },
  computed: {
    phoneNumber: {
      get(): string {
        return store.state.location.phoneNumber
      },
      set(value: string) {
        store.commit('location/phoneNumber', value)
      }
    },
    isUserAdmin() {
      const user = store.state.authentication.currentUser
      return user && (user.isAdmin || user.isTeamAdmin || user.isAgencyAdmin)
    },
    smAndDown(): any {
      return this.$vuetify.breakpoint.smAndDown
    },
    user(): any {
      return store.state.authentication.currentUser
    },
  },
  components: {
    EndTrackingModal
  }
})
</script>
<style lang="scss" scoped>
.v-step {
  z-index: 100;
}

.headline {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

v-list-item-title {
  background-color: transparent;
  font-weight: unset;
}

.user-menu-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

.user-name {
  font-size: 15px;
  font-weight: 500;
}

:deep(.user-menu) {
  margin-top: 8px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #e5e7eb;
}

.user-menu-list {
  padding: 4px;
  
  .v-list-item {
    border-radius: 6px;
    margin: 2px 0;
    
    &:hover {
      background: #f3f4f6 !important;
    }
  }
  
  .sign-out-item {
    &:hover {
      background: #fee2e2 !important;
      
      .v-list-item__title {
        color: #dc2626 !important;
      }
    }
  }
}

</style>
